import { useMutation, useQuery } from "@tanstack/react-query";
import {
  adminResetOwnerPassword,
  type AdminResetOwnerPasswordPayload,
  createSuperuser,
  type CreateSuperuserPayload,
  resetPassword,
  type ResetPasswordPayload,
  searchOwnerAccounts
} from "./api";

export const useResetPassword = () =>
  useMutation({
    mutationFn: async (payload: ResetPasswordPayload) => resetPassword(payload)
  });

export const useCreateSuperuser = () =>
  useMutation({
    mutationFn: async (payload: CreateSuperuserPayload) => createSuperuser(payload)
  });

export const useAdminResetOwnerPassword = () =>
  useMutation({
    mutationFn: async (payload: AdminResetOwnerPasswordPayload) =>
      adminResetOwnerPassword(payload)
  });

export const useSearchOwnerAccounts = (q: string) =>
  useQuery({
    queryKey: ["owner-accounts-search", q],
    queryFn: () => searchOwnerAccounts(q),
    enabled: q.trim().length >= 2,
    staleTime: 60_000
  });
